import React from "react";
import AssessmentForm from "./AssessmentForm";

export default function AddAssessmentForm({ onSave, onCancel }) {
  function handleSave(data) {
    // 🔹 In future: call POST /assessments with data
    console.log("AddAssessmentForm save payload:", data);
    onSave?.(data);
  }

  return (
    <AssessmentForm
      initialData={null}
      mode="add"
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
}